/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import LeadPreview from 'DesignSystem/LeadPreview/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/New/SimilarPatients/Content/Content/SimilarPerson/Lead/Details/Content",
  handleClose
  
}) {
let similarPersonIdValueData = fromData.useDataValue({ viewPath,
context: 'similar_person',
path: 'id',
})
  return (<React.Fragment
>
<LeadPreview
  viewPath={`${viewPath}/LeadPreview`}
 data="similar_person.id"
 leadId={similarPersonIdValueData}
 showNextActions={false}
 handleClose={handleClose}
 hideActions={true}
/>
{children}
</React.Fragment>)
}